// extracted by mini-css-extract-plugin
export default {"mobileWidth":"980px","desktopWidth":"1520px","root":"topAward_root__GEq8X","title":"topAward_title__OZ-84"};